import request from "@/api/request";

//查询井列表
export function rainWellList(data) {
    return request({
        url: '/model-analysis/pipeInfo/rainWellList',
        method: 'post',
        data,
    })
}
export function rainList(data) {
    return request({
        url: '/model-analysis/pipeInfo/rainList',
        method: 'post',
        data,
    })
}
export function sewageWellList(data) {
    return request({
        url: '/model-analysis/pipeInfo/sewageWellList',
        method: 'post',
        data,
    })
}
export function sewageList(data) {
    return request({
        url: '/model-analysis/pipeInfo/sewageList',
        method: 'post',
        data,
    })
}
export function pumpList(data) {
    return request({
        url: '/model-analysis/pipeInfo/pumpList',
        method: 'post',
        data,
    })
}
export function savePump(data) {
    return request({
        url: '/model-analysis/pipeInfo/savePump',
        method: 'post',
        data,
    })
}
export function saveRainWell(data) {
    return request({
        url: '/model-analysis/pipeInfo/saveRainWell',
        method: 'post',
        data,
    })
}
export function saveRain(data) {
    return request({
        url: '/model-analysis/pipeInfo/saveRain',
        method: 'post',
        data,
    })
}
export function saveSewageWell(data) {
    return request({
        url: '/model-analysis/pipeInfo/saveSewageWell',
        method: 'post',
        data,
    })
}
export function saveSewage(data) {
    return request({
        url: '/model-analysis/pipeInfo/saveSewage',
        method: 'post',
        data,
    })
}
export function modifyPump(data) {
    return request({
        url: '/model-analysis/pipeInfo/modifyPump',
        method: 'post',
        data,
    })
}
export function modifyRainWell(data) {
    return request({
        url: '/model-analysis/pipeInfo/modifyRainWell',
        method: 'post',
        data,
    })
}
export function modifyRain(data) {
    return request({
        url: '/model-analysis/pipeInfo/modifyRain',
        method: 'post',
        data,
    })
}
export function modifySewageWell(data) {
    return request({
        url: '/model-analysis/pipeInfo/modifySewageWell',
        method: 'post',
        data,
    })
}
export function modifySewage(data) {
    return request({
        url: '/model-analysis/pipeInfo/modifySewage',
        method: 'post',
        data,
    })
}

export function remove({ id, type }) {

    return request({
        url: '/model-analysis/pipeInfo/delete/' + id + '/' + type,
        method: 'post'
    })
}

export function fetchDetail(data) {
    return request({
        url: `/model-analysis/pipeInfo/query/${data.id}/${data.type}`,
    })
}

export function getDiameterLengthSum(data) {
    return request({
        url: `/model-analysis/pipeInfo/diameter-length-sum/${data.type}`,
    })
}